import { ITranslationEntry } from '../lang';

export const KO: ITranslationEntry = {
  translations: {
    notifications: '알림',
    markAllAsRead: '모두 읽은 상태로 표시',
    poweredBy: '에 의해 구동',
    settings: '설정',
  },
  lang: 'ko',
};
